<mat-chip-set>
  @for (pkg of groupedBundles(); track pkg) {
    <mat-chip
      elderChipLabel
      [namedColor]="pkg.detail?.isUsedShared ? 'orange' : 'blue'"
      elderStopEventPropagation
      (click)="onClick(pkg)"
    >
      <mat-icon matChipAvatar [color]="bundleIconColor(pkg.detail)">
        {{ bundleIcon(pkg.detail) }}
      </mat-icon>
      <div class="layout-col place-center-center">
        <span
          [style.lineHeight]="detailedView() ? '16px' : 'inherit'"
          matBadge="{{ pkg.itemBundles.length }}"
          matBadgeOverlap="false"
          matBadgeHidden="{{ pkg.itemBundles.length === 1 || detailedView() }}"
        >
          {{ detailedView() ? pkg.packageNumber : trimPackageNumber(pkg.packageNumber) }}
        </span>
        @if (detailedView()) {
          <div class="layout-row">
            @for (itemBundle of pkg.itemBundles; track itemBundle; let isLast = $last) {
              <span class="text-body-small" [style.lineHeight]="'16px'">
                ({{ itemBundle.quantity | elderQuantity }}){{ isLast ? '' : ', ' }}
              </span>
            }
          </div>
        }
      </div>
    </mat-chip>
  }
</mat-chip-set>
